import axios from 'axios'
import { Button, Grid, TextField, Typography } from 'material-ui'
import { InputLabelProps } from 'material-ui/Input'
import * as React from 'react'
import { FormEventHandler } from 'react'
import { RouteComponentProps } from 'react-router'
import { ProjectSelectorCard, ProjectSelectorTitle } from './ProjectSelectorCard'
import { SpreadBody } from './SpreadBody'
import { SpreadHeading } from './SpreadHeading'

interface Props {}

interface State {
    name: string,
    email: string,
    message: string,
    success: boolean
}

/* tslint:disable:member-ordering */
export class ContactPage extends React.Component<RouteComponentProps<Props, {}>, State> {

    state: State = {
        name: '',
        email: '',
        message: '',
        success: false
    }

    private slackUrl = 'https://hooks.slack.com/services/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'

    componentDidMount() {
        window.scroll(0, 0)
    }

    sendMessage = () => {
        const {name, email, message} = this.state
        this.postToSlack(name, email, message).then(() => {
            this.setState({success: true})
        })
    }

    private postToSlack = (name: string, email: string, message: string) =>
        axios.post(this.slackUrl, JSON.stringify({
            text: `*NAME:* ${name}\n*EMAIL:* ${email}\n${message}`,
            username: 'New Contact',
            icon_emoji: ':phone:'
        }))

    formEventHandler = (handler: (v: string) => void): FormEventHandler<HTMLInputElement> =>
        (e) => handler(e.currentTarget.value)

    updateName = this.formEventHandler(name => this.setState({name}))
    updateEmail = this.formEventHandler(email => this.setState({email}))
    updateMessage = this.formEventHandler(message => this.setState({message}))

    textFieldInput = {
        background: '#fff',
        border: '1px solid #ced4da',
        padding: '5px 12px',
        width: 'calc(100% - 24px)',
        '&:focus': {
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
        borderRadius: 1
    }
    inputLabelProps: InputLabelProps = {
        shrink: true,
        style: {fontFamily: '"Saira Semi Condensed", sans-serif', fontSize: 20, top: -5, height: 30, color: '#404040'}
    }

    ContactForm = () => {
        return (

            <div style={{marginTop: 20}}>
                <Grid container>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            value={this.state.name}
                            label='Name'
                            onChange={this.updateName}
                            InputProps={{
                                disableUnderline: true,
                                style: this.textFieldInput
                            }}
                            InputLabelProps={this.inputLabelProps}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            value={this.state.email}
                            label='Email'
                            onChange={this.updateEmail}
                            InputProps={{
                                disableUnderline: true,
                                style: this.textFieldInput
                            }}
                            InputLabelProps={this.inputLabelProps}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            value={this.state.message}
                            label={'What\'s up?'}
                            onChange={this.updateMessage}
                            style={{minHeight: 80}}
                            InputProps={{
                                disableUnderline: true,
                                style: this.textFieldInput
                            }}
                            InputLabelProps={this.inputLabelProps}
                        />
                    </Grid>
                </Grid>

                <div style={{textAlign: 'right', margin: '20px 0'}}>
                    <Button
                        color='contrast'
                        onClick={this.sendMessage}
                        style={{
                            padding: '15px 70px',
                            borderRadius: 30,
                            background: 'linear-gradient(-225deg, #6CCC31 0%, #62A744 100%)'
                        }}
                    >
                        <Typography type='title' style={{color: '#fff', fontSize: 16, lineHeight: 2}}>
                            Send
                        </Typography>
                    </Button>
                </div>
            </div>
        )
    }

    Success = () => {
        return (
            <div>
                <Typography type='title' style={{lineHeight: '2em', marginTop: 15}}>
                    Thanks for reaching out! We'll get back to you in the next few days to talk more.
                </Typography>
            </div>
        )
    }

    OtherStories = () => {
        return (

            <div>
                <Grid container>
                    <Grid item xs={12} sm={4}>
                        <ProjectSelectorCard
                            img='/img/avant-link-photo-blue.png'
                            color='#36426a'
                            height={200}
                            onClick={() => this.props.router.push('/avant')}
                        >
                            <ProjectSelectorTitle small title='Avant Assessment' sub='Partner Story'/>
                        </ProjectSelectorCard>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <ProjectSelectorCard
                            img='/img/xprize-link-photo-gold.png'
                            color='#36426a'
                            height={200}
                            onClick={() => this.props.router.push('/xprize')}
                        >
                            <ProjectSelectorTitle small title='XPRIZE' sub='Partner Story'/>
                        </ProjectSelectorCard>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <ProjectSelectorCard
                            img='/img/partner-link-photo-green.png'
                            color='#36426a'
                            height={200}
                            onClick={() => this.props.router.push('/random-lengths')}
                        >
                            <ProjectSelectorTitle small title='Random Lengths' sub='Partner Story'/>
                        </ProjectSelectorCard>
                    </Grid>
                </Grid>
            </div>
        )
    }

    Contacts = () => {
        return (

            <div>
                <Typography type='title' style={{fontSize: 16, lineHeight: '2em', marginTop: 15}}>
                    General Inquiries
                </Typography>
                {/*<Typography type='subheading' style={{fontSize: 16, color: '#9B9B9B'}}>*/}
                {/*(650) 690-2914*/}
                {/*</Typography>*/}
                <Typography type='subheading' style={{fontSize: 16}}>
                    <a href='mailto:info@twentyideas.com'>info@twentyideas.com</a>
                </Typography>
                <Typography type='title' style={{fontSize: 16, lineHeight: '2em', marginTop: 15}}>
                    Join the Team
                </Typography>
                <Typography type='subheading' style={{fontSize: 16}}>
                    <a href='mailto:careers@twentyideas.com'>careers@twentyideas.com</a>
                </Typography>
                <Typography type='title' style={{fontSize: 16, lineHeight: '2em', marginTop: 15}}>
                    Send us a Letter
                </Typography>
                <Typography type='subheading' style={{fontSize: 16}}>
                    44 W. Broadway, Suite #222 <br/>
                    Eugene, OR
                </Typography>
            </div>
        )
    }

    render() {

        const {ContactForm, Success, Contacts, OtherStories} = this

        return (
            <div>
                <SpreadBody xl>
                    <SpreadHeading title='Partner Stories'/>
                    <div style={{height: 60, position: 'absolute', top: 20, right: 20}}>
                        <img
                            src='/img/nav/close.svg'
                            alt='close'
                            onClick={this.props.router.goBack}
                            style={{padding: 5, cursor: 'pointer', height: 30}}
                        />
                    </div>
                    <OtherStories/>
                </SpreadBody>
                <SpreadBody greyBg xl>
                    <Grid container>
                        <Grid item xs={12} sm={8}>
                            <SpreadHeading title='Get in Touch'/>
                            <Typography type='subheading' style={{lineHeight: '2em', marginTop: 15}}>
                                Fill this form out so we have a basic understanding of your needs.
                            </Typography>

                            {this.state.success ? <Success/> : <ContactForm/>}

                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Contacts/>
                        </Grid>
                    </Grid>
                </SpreadBody>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/ContactPage.tsx